<template>
  <div class="fertilizer">
    <div class="box">
      <p class="dim">
        From: "Filmore Ting" &lt;stefano@talk21.com&gt;
        <br>To: &#9608;&#9608;&#9608;&#9608;&#9608;&#9608;&#9608;&#9608;@gmail.com
        <br>Subject: VlAthuGRA
        <br>Date: Fri, 29 Feb 2008 09:29:21 +0000
      </p>
      <p>
        I guess so. From his limp hands as he fell by. Placed it on his sleeping chest. Scientific interest for the specialists to
        examine. It didn't look like a weapon of some kind. Fido has done its job and freed him.
      </p>
    </div>
    <div class="updated">29 II 2008</div>
  </div>
</template>

<script>
export default {
  name: "vlathugra"
};
</script>

<style scoped>
.fertilizer {
  background: #fff;
}

.box {
  color: #000;
  font-size: 1.8em;
  width: 600px;
  text-align: left;
  left: 50%;
  margin-left: -300px;
  margin-top: -180px;
}

.box p {
  line-height: 1.5em;
}

.box p.dim {
  line-height: 1.5em;
  color: #999;
}

.updated {
  color: #c0c0c0;
}
</style>
